<template functional>
  <div :class="data.staticClass" class="ql-snow w-full">
    <div class="ql-editor" v-html="props.data" />
  </div>
</template>

<script>
export default {
  name: 'TextEditorViewer'
}
</script>
